module.exports = __webpack_public_path__ + "static/media/calendar.e7882147.svg";